import AccountProfile from "pages/Account/Profile";
import MultiStepForm from "pages/ApplicationForm";
import ApplicationComplete from "pages/ApplicationForm/ApplicationComplete";
import CaseDetail from "pages/CaseDetail";
import LegacyCaseDetail from "pages/CaseDetailLegacy";
import CaseDocuments from "pages/CaseDocuments";
import CaseTracker from "pages/CaseTracker";
import Cases from "pages/Cases";
import RoleDashboard from "pages/Dashboard/RoleDashboard";
import DebtConsolidationForm from "pages/DebtConsolidation";
import Resources from "pages/Resources";
import { RouteType } from "routes/types";
import { APP_URLS } from "settings";

const COMMON_ROUTES: RouteType[] = [
  {
    path: APP_URLS.DASHBOARD,
    component: RoleDashboard,
    title: "Dashboard",
  },
  {
    path: APP_URLS.ACCOUNT.ACCOUNT_PROFILE,
    component: AccountProfile,
    title: "Account profile",
  },
  {
    path: `${APP_URLS.CASE_MANAGEMENT}`,
    component: Cases,
    title: "Cases",
  },
  // Temporary while we test the new case tracker: reachable by URL only and
  // not linked from the nav. /cases still shows the existing case list.
  {
    path: APP_URLS.CASE_TRACKER,
    component: CaseTracker,
    title: "Case tracker",
  },
  {
    path: APP_URLS.CASE_TRACKER_DETAIL,
    component: CaseDetail,
    title: "Case details",
  },
  {
    path: `${APP_URLS.CASE_DETAIL}`,
    component: LegacyCaseDetail,
    title: "Case",
  },
  {
    path: `${APP_URLS.CASE_DOCUMENTS}/`,
    component: CaseDocuments,
    title: "Case documents",
  },
  {
    path: `${APP_URLS.CASE_DEBT_CONSOLIDATION}`,
    component: DebtConsolidationForm,
    title: "Debt consolidation",
  },
  {
    path: `${APP_URLS.RESOURCES}/:resourceType`,
    component: Resources,
    title: "Resources",
  },
  {
    path: `${APP_URLS.RESOURCES}`,
    component: Resources,
    title: "Resources",
  },
];

const BROKER_ROUTES: RouteType[] = [
  ...[
    {
      path: `${APP_URLS.APPLICATION_FORM}/:applicationId/complete`,
      component: ApplicationComplete,
      title: "Application submitted",
    },
    {
      path: `${APP_URLS.APPLICATION_FORM}/:applicationId/:step`,
      component: MultiStepForm,
      title: "Application form",
    },
    {
      path: `${APP_URLS.APPLICATION_FORM}/:step`,
      component: MultiStepForm,
      title: "Application form",
    },
    {
      path: `${APP_URLS.APPLICATION_FORM}/`,
      component: MultiStepForm,
      title: "Application form",
    },
  ],
];

const ADMIN_ROUTES: RouteType[] = [];

const ROUTES = {
  COMMON_ROUTES,
  ADMIN_ROUTES,
  BROKER_ROUTES,
};

export default ROUTES;
